import { useState } from 'react'

// constants/deviceTypes.ts
export const deviceTypes = {
  all: 'all',
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
} as const

export type DeviceType = typeof deviceTypes[keyof typeof deviceTypes]

export const useDeviceSelector = () => {
  const [selectedDevice, setSelectedDevice] = useState<DeviceType>('all')

  return {
    selectedDevice,
    setSelectedDevice,
    isMobile: selectedDevice === 'mobile',
    isTablet: selectedDevice === 'tablet',
    isDesktop: selectedDevice === 'desktop',
    isAll: selectedDevice === 'all',
  }
}
